export default __webpack_public_path__ + "static/Bitrate_Test_11_WDRMODE_0_Indoor_1600000-f1a8f4e86d461f3e7f7a9b2f2e84e0a5.avif";